/* eslint-disable react/destructuring-assignment */
import React from 'react';
import {
  COMMUNICATION_TYPE,
  STATUS_TYPE,
  STATUS_TYPE_COLOR,
} from '../../../../shared/utils/constants';
import { textEllipsis } from '../../../../shared/utils/smartutils';

export default function (t, correctionType) {
  const columns = [
    {
      title: t('general.student'),
      field: 'student.fullName',
      cellStyle: {
        ...textEllipsis,
      },
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.student.fullName}>
          {rowData.student.fullName}
        </span>
      ),
    },
    {
      title: t('general.status'),
      field: 'formattedStatus',
      cellStyle: {
        minWidth: 100,
      },
      render: (rowData) => {
        let color;
        const { formattedStatus, status } = rowData;
        switch (status) {
          case STATUS_TYPE.CONCLUDED:
            color = STATUS_TYPE_COLOR.GREEN;
            break;
          case STATUS_TYPE.IN_REVISION:
            color = STATUS_TYPE_COLOR.ORANGE;
            break;
          case STATUS_TYPE.UN_CONCLUDED:
            color = STATUS_TYPE_COLOR.RED;
            break;
          case STATUS_TYPE.ANSWERED:
            color = STATUS_TYPE_COLOR.GREEN;
            break;
          default:
            color = STATUS_TYPE_COLOR.RED;
            break;
        }
        return (
          <div
            className="m-0 w-50 d-flex justify-content-center p-1 rounded text-white"
            style={{ backgroundColor: color }}
          >
            {formattedStatus}
          </div>
        );
      },
    },
  ];
  if (correctionType === COMMUNICATION_TYPE.EXAM) {
    columns.push({
      title: t('general.result'),
      field: 'grade',
    });
  }
  if (correctionType === COMMUNICATION_TYPE.ACTIVITY) {
    columns.push({
      title: t('communication.activityDetails.answerDate'),
      field: 'formattedDeliveryDate',
    });
  }

  return columns;
}
